
// selectors.js
// Selectors.js

export const selectAuthenticated = (state) => state.auth.authenticated;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectRefreshToken = (state) => state.auth.refreshToken;
export const selectUserData = (state) => state.auth.user_data;
